export const iconFontAwesomeArrowsChevronRight = (
	<i className="fa-solid fa-chevron-right"></i>
);
